
















// Importing components
import BaseSection from '@/ui/BaseSection.vue';
import BaseStepByStep from '@/ui/BaseStepByStep.vue';

export default {
    name: 'TheWelcomeSteps',
    components: {
        BaseSection,
        BaseStepByStep,
    },
};
